{
  "title": "Which cookies do you want to allow?",
  "disclaimer": "You can choose for which purposes you want to allow cookieson our website",
  "alertTitle": "Cookies on %{title}",
  "alertBigPrivacy": "By clicking “Accept All Cookies”, you agree to the storing of cookies on your device to enhance site navigation, analyze site usage, and assist in our communication efforts. ",
  "externalLinkText": "More information",
  "confirm": "Save preferences",
  "allow": "Allow",
  "deny": "Deny",
  "allowAll": "Accept all",
  "denyAll": "Deny all",
  "alertAllowAll": "Accept all cookies",
  "alertSettings": "Cookies Settings",
  "close": "Close",
  "services": {
    "mandatory": {
      "title": "Functional",
      "details": "Functional cookies are used to ensure the website works. Therefore you cannot refuse them. These cookies also allow us to map the general use of our website by making use of anonymized data."
    },
    "performance": {
      "title": "Performance",
      "details": "These cookies allow us to count visits and traffic sources so we can measure and improve the performance of our site. They help us to know which pages are the most and least popular and see how visitors move around the site. All information these cookies collect is aggregated and therefore anonymous. If you do not allow these cookies we will not know when you have visited our site, and will not be able to monitor its performance."
    },
    "features": {
      "title": "Features",
      "details": "These cookies enable the website to provide enhanced functionality and personalisation. They may be set by us or by third party providers whose services we have added to our pages. If you do not allow these cookies then some or all of these services may not function properly."
    },
    "ads": {
      "title": "Marketing",
      "details": "We use these cookies to use your online behaviour for our own marketing purposes and analysis. These cookies enable us to show you advertisements on other websites or apps, both within as well as outside"
    }
  }
}
